import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
const firebaseConfig = {
    apiKey: "AIzaSyBXjMCR5aosA5LOi7KtPnjnj5JR7W9tFW0",
    authDomain: "fir-learning-5cb05.firebaseapp.com",
    projectId: "fir-learning-5cb05",
    storageBucket: "fir-learning-5cb05.appspot.com",
    messagingSenderId: "326097962958",
    appId: "1:326097962958:web:a240035fe4924eddff8d9f",
    measurementId: "G-MGQ3512PQE"
};
const app = firebase.initializeApp(firebaseConfig);
export default app;